import $ from "jquery";
import {ReactNode, useEffect, useState} from "react";
import "../../styles/css/admin-style.css"
import {useLocation} from "react-router-dom";
import {JSX} from "react"
import NewSuperAdminModal from "../../components/super-admin-management/NewSuperAdminModal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCog,
    faPlus,
    faUserShield,
    faUsers,
    faFileImport,
    faTrash,
    faFileExport, faSearch, faFileInvoice, faCalendarDay
} from "@fortawesome/free-solid-svg-icons";
import {Button, ButtonGroup, Dropdown} from "react-bootstrap";
import eventEmitter from "../eventEmitter";
import {faCalendar, faSave, faFileCode, faCreditCard, faCalendarAlt, faFileArchive} from "@fortawesome/free-regular-svg-icons";
import {EventEmitterTypes} from "../eventEmitterEnum";
import NewYearSetupModal from "../../components/yearly-settings/modals/NewYearSetupModal";
import NewCustomerModal from "../../components/customer-management/NewCustomerModal";
import {ModalData, ModalName} from "./PageWrapper";
import {PageData, usePageData} from "./PageContext";
import CopyOverJobsNewYearModal from "../../components/yearly-settings/modals/CopyOverJobsNewYearModal";

interface HeaderProps {
    toggleSidebar: () => void;
    activeModal: ModalName | null
    modalData: ModalData | null
    openModal(name: ModalName, data?: any): void
    closeModal(): void
}

interface HeaderButton {
    id: string;
    label: JSX.Element | string;
    onClick: () => void;
}

interface HeaderConfig {
    headerText: JSX.Element;
    buttons?: HeaderButton[];
    customContent?: JSX.Element;
    buttonWrapperClass?: string;
}

type HeaderConfigGenerator = {
    match: (path: string) => boolean;
    render: (openModal: (modal: string) => void, path: string, pageData: PageData) => HeaderConfig;
};

const headerConfigs: HeaderConfigGenerator[] = [
    {
        match: (path) => path.includes('estimate-details'),
        render: () => ({
            headerText: (
                <h1 className="mb-0 me-3">
                    <FontAwesomeIcon icon={faFileInvoice} /> Estimate Details
                </h1>
            ),
        }),
    },
    {
        match: (path) => path.includes('deposit-slips'),
        render: () => ({
            headerText: (
                <h1
                    className="mb-0 me-3"
                    dangerouslySetInnerHTML={{
                        __html: '<i class="fa-light fa-money-simple-from-bracket"></i> Deposit Slips',
                    }}
                ></h1>
            ),
        }),
    },
    {
        match: (path) => path.includes('estimates'),
        render: () => ({
            headerText: (
                <h1 className="mb-0 me-3">
                    <FontAwesomeIcon icon={faFileInvoice} /> Estimates
                </h1>
            ),
        }),
    },
    {
        match: (path) => path.includes('web-not-run'),
        render: () => ({
            headerText: (
                <h1 className="mb-0 me-3">
                    <FontAwesomeIcon icon={faCreditCard} /> Web Not Run
                </h1>
            ),
        }),
    },
    {
        match: (path) => path.includes('scheduled-jobs'),
        render: () => ({
            headerText: (
                <h1 className="mb-0 me-3">
                    <FontAwesomeIcon icon={faCalendarDay} /> Scheduled Jobs
                </h1>
            ),
        }),
    },
    {
        match: (path) => path.includes('yearly-settings/details'),
        render: (openModal, path, pageData) => {
            const match = path.match(/yearly-settings\/details\/(\d+)/);
            const year = match ? match[1] : '';
            return {
                headerText: (
                    <h1 className="mb-0 me-3">
                        <>
                            <FontAwesomeIcon icon={faCalendar}/> {pageData.year} Settings
                        </>
                    </h1>
                ),
                buttons: [
                    {
                        id: 'copyPreviousYears',
                        hide: !pageData.canCopyJobsFromPreviousYear,
                        label: (
                            <>
                                <FontAwesomeIcon icon={faCog}/> Set Up New Year Jobs
                            </>
                        ),
                        onClick: () => openModal('copyPreviousYears'),
                    },
                ],
            };
        },
    },
    
    {
        match: (path) => path.includes('reports'),
        render: () => {
            return {
                headerText: (
                    <h1 className="mb-0 me-3">
                        <FontAwesomeIcon icon={faFileExport}/> Reports
                    </h1>
                ),
            };
        },
    },
    {
        match: (path) => path.includes('yearly-settings'),
        render: (openModal) => ({
            headerText: (
                <h1 className="mb-0 me-3">
                <FontAwesomeIcon icon={faCalendar} /> Yearly Settings
                </h1>
            ),
            buttons: [
                {
                    id: 'newSuperAdmin',
                    label: (
                        <>
                            <FontAwesomeIcon icon={faCog}/> New Year
                        </>
                    ),
                    onClick: () => openModal('newYearSetup'),
                },
            ],
        }),
    },
    {
        match: (path) => path.includes('management'),
        render: (openModal) => ({
            headerText: (
                <h1 className="mb-0 me-3">
                    <FontAwesomeIcon icon={faUserShield} /> Admins
                </h1>
            ),
            buttons: [
                {
                    id: 'newSuperAdmin',
                    label: (
                        <>
                            <FontAwesomeIcon icon={faPlus} /> New Admin
                        </>
                    ),
                    onClick: () => openModal('newSuperAdmin'),
                },
            ],
        }),
    },
    {
        match: (path) => path.includes('customers'),
        render: (openModal) => ({
            headerText: (
                <h1 className="mb-0 me-3">
                    <FontAwesomeIcon icon={faUsers} /> Search
                </h1>
            ),
            buttons: [
                {
                    id: 'newCustomer',
                    label: (
                        <>
                            <FontAwesomeIcon icon={faPlus} /> Add Customer
                        </>
                    ),
                    onClick: () => openModal('newCustomer'),
                },
            ],
            /* OLD CONTENT. KEPT IN FOR REFERENCE TO MANY BUTTONS IN ONE HEADER. CAN DELETE WHEN NO LONGER NEEDED
            customContent: (
                <div className="d-flex align-items-center justify-content-end">

                    <button type="button" onClick={() => eventEmitter.emit(EventEmitterTypes.CUSTOMER_ADD)} className="btn btn-success text-white fw-medium hvr-grow me-2"><i
                        className="fa-regular fa-plus"></i> add
                    </button>

                    <button type="button" onClick={() => eventEmitter.emit(EventEmitterTypes.CUSTOMER_SEARCH)} className="btn btn-secondary fw-medium hvr-grow me-2">
                        <i className="fa-regular fa-search"></i> find
                    </button>

                    <ButtonGroup className="me-2">
                        <Button
                            variant="primary"
                            onClick={() => eventEmitter.emit(EventEmitterTypes.CUSTOMER_SAVE)}
                            className={'btn btn-primary fw-medium'}
                        >
                            <i className="fa-regular fa-save"></i> save
                        </Button>
                        <Dropdown as={ButtonGroup}>
                            <Dropdown.Toggle variant="primary" id="dropdown-split-basic" />
                            <Dropdown.Menu align="end">
                                <Dropdown.Item onClick={() => eventEmitter.emit(EventEmitterTypes.CUSTOMER_ADD_ANOTHER)}>
                                    <i className="fa-regular fa-floppy-disk-circle-arrow-right me-2"></i> Save & Add Another
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </ButtonGroup>

                    <Dropdown align="end">
                        <Dropdown.Toggle variant="outline-dark" id="dropdown-basic">
                            more
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="#import">
                                <i className="fa-regular fa-file-import me-2"/>
                                    Import
                            </Dropdown.Item>
                            <Dropdown.Item href="#export">
                            <i className="fa-regular fa-file-export me-2"/>
                                    Export
                            </Dropdown.Item>
                            <Dropdown.Item href="#delete" className="text-danger">
                                <i className="fa-regular fa-trash me-2"/>
                                Delete
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),*/
        }),
    },
];

const Header: React.FC<HeaderProps> = ({toggleSidebar, activeModal, openModal, modalData, closeModal,}) => {
    const location = useLocation();
    const { pageData } = usePageData();
    const [headerConfig, setHeaderConfig] = useState<any>(null)

    useEffect(() => {
        const path = location.pathname
        const cfg = headerConfigs.find((c) => c.match(path))
        setHeaderConfig(cfg?.render(openModal, path, pageData) ?? {
            headerText: <h1 className="mb-0 me-3">Barreca</h1>,
        })
    }, [location.pathname, pageData])


    const renderHeaderContent = () => {
        if (!headerConfig) return null;
        if (headerConfig.customContent) {
            return headerConfig.customContent;
        }
        if (headerConfig.buttons && headerConfig.buttons.length > 0) {
            const buttons = headerConfig.buttons.map((button) => {
                if(!button.hide){
                    return <>
                        <button
                            key={button.id}
                            onClick={button.onClick}
                            type="button"
                            className="btn btn-primary text-strong hvr-grow me-2"
                        >
                            {button.label}
                        </button>
                    </>
                }
                else return <></>
            });
            return headerConfig.buttonWrapperClass ? (
                <div className={headerConfig.buttonWrapperClass}>{buttons}</div>
            ) : (
                buttons
            );
        }
        return null;
    };

    return (
        <>
            <div className="container-fluid d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <button
                        className="btn btn-primary me-2"
                        id="sidebarToggle"
                        onClick={toggleSidebar}
                    >
                        <i className="fa-regular fa-bars"></i>
                    </button>
                    {headerConfig && headerConfig.headerText}
                </div>
                <div>{renderHeaderContent()}</div>
            </div>

            {/* Conditionally render modals */}
            {activeModal === 'newSuperAdmin' && (
                <NewSuperAdminModal toggle={() => closeModal()} show={true} />
            )}
            {activeModal === 'newYearSetup' && (
                <NewYearSetupModal toggle={() => closeModal()} show={true} />
            )}
            {activeModal === 'newCustomer' && (
                <NewCustomerModal toggle={() => closeModal()} show={true} />
            )}
            {activeModal === 'copyPreviousYears' && (
                <CopyOverJobsNewYearModal toggle={() => closeModal()} show={true} data={pageData}/>
            )}
        </>
    );
};

export default Header;
